import { useEffect, useState } from 'react';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';
import Footer from '../../components/Footer';
import DateInput from '../../components/DateInput';

export default function GerenciamentoCalendario() {    
    const { showNotification } = useNotification();

    const [dataLimite, setDataLimite] = useState('');
    const [periodoRepos, setPeriodoRepos] = useState({ data_inicio: '', data_fim: '' });
    const [periodoExclusao, setPeriodoExclusao] = useState({ data_inicio: '', data_fim: '' });
    const [antecedenciaReposicao, setAntecedenciaReposicao] = useState('');

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const response = await authFetch('config-parameter', {                    
                });

                if (!response.ok) throw new Error('Erro ao buscar parâmetros');

                const data = await response.json();

                setDataLimite(data.maxCalendarDate);
                setPeriodoRepos({
                    data_inicio: data.appointmentRescheduleStartDate,
                    data_fim: data.appointmentRescheduleEndDate
                });
                setAntecedenciaReposicao(
                    data.rescheduleMinAdvanceHours != null
                        ? String(data.rescheduleMinAdvanceHours)
                        : ''
                );

            } catch (error) {
                console.error(error);
                showNotification("danger", "Erro ao buscar parâmetros");
            }

        };
        fetchConfig();
    }, []);

    const handleSalvarConfig = async (e) => {
        e.preventDefault();

        const horas = parseInt(antecedenciaReposicao, 10);
        if (antecedenciaReposicao !== '' && (isNaN(horas) || horas < 0)) {
            showNotification('danger', 'Informe um valor válido em horas');
            return;
        }

        const payload = {
            id: 1,
            maxCalendarDate: dataLimite,
            appointmentRescheduleStartDate: periodoRepos.data_inicio,
            appointmentRescheduleEndDate: periodoRepos.data_fim,
            rescheduleMinAdvanceHours: antecedenciaReposicao === '' ? null : horas,
        };

        try {
            const response = await authFetch('config-parameter', {
                method: 'PUT',
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error();

            showNotification('success', 'Configurações salvas com sucesso!');
        } catch {
            showNotification('danger', 'Erro ao salvar configurações');
        }
    };

    const handleExclusaoLote = async (e) => {
        e.preventDefault();

        try {
            const res = await authFetch('appointment', {                
            });

            if (!res.ok) throw new Error('Erro ao buscar agendamentos');

            const todosAgendamentos = await res.json();

            const dataInicioFiltro = new Date(periodoExclusao.data_inicio);
            const dataFimFiltro = new Date(periodoExclusao.data_fim);

            const agendamentosFiltrados = todosAgendamentos.filter((item) => {
                const dataInicioItem = new Date(item.data_inicio);
                return dataInicioItem >= dataInicioFiltro && dataInicioItem <= dataFimFiltro;
            });

            if (agendamentosFiltrados.length === 0) {
                showNotification('Nenhum agendamento encontrado no período informado.', 'info');
                return;
            }

            for (const agendamento of agendamentosFiltrados) {
                await authFetch(`'appointment'/${agendamento.id}`, {
                    method: 'DELETE',
                });
            }

            showNotification('Agendamentos excluídos com sucesso.', 'success');
        } catch (error) {
            console.error(error);
            showNotification('Erro ao excluir agendamentos.', 'error');
        }
    };


    return (
        <div className="content">
            <h3 className="font-weight-bolder mb-3">Gerenciamento do Calendário</h3>

            <div className="card mb-4">
                <div className="card-body p-3">

                    <form onSubmit={handleSalvarConfig}>
                        <h6>Limite de Visualização da Agenda</h6>
                        <div className="row">
                            <label>Data Limite de Liberação da Agenda para as Terapeutas</label>
                            <div className="col-md-2">
                                <DateInput
                                    className="form-control form-control-sm"
                                    value={dataLimite}
                                    onChange={(e) => setDataLimite(e.target.value)}
                                    placeholder="dd/MM/yyyy"
                                    inputMode="numeric"
                                />
                            </div>
                        </div>

                        <hr />

                        <h6>Período de Apuração das Reposições</h6>
                        <div className="row">
                            <label>Altere o Período de Apuração das Reposições</label>
                            <div className="col-md-2">
                                <label>Início</label>
                                <DateInput
                                    className="form-control form-control-sm"
                                    value={periodoRepos.data_inicio}
                                    onChange={(e) =>
                                        setPeriodoRepos({ ...periodoRepos, data_inicio: e.target.value })
                                    }
                                    placeholder="dd/MM/yyyy"
                                    inputMode="numeric"
                                />
                            </div>
                            <div className="col-md-2">
                                <label>Término</label>
                                <DateInput
                                    className="form-control form-control-sm"
                                    value={periodoRepos.data_fim}
                                    onChange={(e) =>
                                        setPeriodoRepos({ ...periodoRepos, data_fim: e.target.value })
                                    }
                                    placeholder="dd/MM/yyyy"
                                    inputMode="numeric"
                                />
                            </div>
                        </div>

                        <hr />

                        <h6>Antecedência Mínima para Reposição sem Cobrança</h6>
                        <div className="row">
                            <div className="col-md-12 mb-2">
                                <label className="form-label mb-1">
                                    Quantidade mínima de horas de antecedência que o responsável deve ter para agendar uma reposição sem cobrança
                                </label>
                            </div>
                            <div className="col-md-3">
                                <div className="d-flex align-items-center gap-2">
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        className="form-control form-control-sm"
                                        style={{ maxWidth: 90 }}
                                        value={antecedenciaReposicao ?? ''}
                                        onChange={(e) =>
                                            setAntecedenciaReposicao(e.target.value.replace(/\D/g, ''))
                                        }
                                    />
                                    <span className="text-sm text-secondary">horas</span>
                                </div>
                            </div>
                        </div>

                        <hr />

                        <div className="d-flex justify-content-end mt-2">
                            <button type="submit" className="btn btn-primary btn-sm">
                                Salvar configurações
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <div className="card">
                <div className="card-body p-3">
                    <h6>Exclusão de Agendamentos em Lote</h6>
                    <form id="form-loteAgend" onSubmit={handleExclusaoLote}>
                        <div className="row">
                            <label>Período de exclusão dos Agendamentos</label>
                            <div className="col-md-2">
                                <label>Início</label>
                                <DateInput
                                    className="form-control form-control-sm"
                                    value={periodoExclusao.data_inicio}
                                    onChange={(e) =>
                                        setPeriodoExclusao({ ...periodoExclusao, data_inicio: e.target.value })
                                    }
                                    placeholder="dd/MM/yyyy"
                                    inputMode="numeric"
                                />
                            </div>
                            <div className="col-md-2">
                                <label>Término</label>
                                <DateInput
                                    className="form-control form-control-sm"
                                    value={periodoExclusao.data_fim}
                                    onChange={(e) =>
                                        setPeriodoExclusao({ ...periodoExclusao, data_fim: e.target.value })
                                    }
                                    placeholder="dd/MM/yyyy"
                                    inputMode="numeric"
                                />
                            </div>
                        </div>
                        <div className="col-md-12 mt-3">
                            <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => window.$('#loteAgend').modal('show')}
                            >
                                Excluir Período
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            {/* Modal Exclusão em Lote */}
            <div
                className="modal fade"
                id="loteAgend"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="loteAgendLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: 600 }}>
                    <div className="modal-content">
                        <div className="modal-header text-center" style={{ display: 'block', paddingBottom: 0 }}>
                            <h5 className="modal-title" id="loteAgendLabel">
                                Excluir agendamentos em lote
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <h5>
                                    Esta ação irá excluir os agendamentos do período selecionado, tem certeza que deseja realizar esta
                                    ação?
                                </h5>
                            </div>
                        </div>
                        <div className="modal-footer text-center">
                            <button type="button" className="btn btn-sm btn-danger" data-bs-dismiss="modal">
                                Cancelar
                            </button>
                            <button type="submit" className="btn btn-sm btn-primary" form="form-loteAgend" data-bs-dismiss="modal">
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
